/**
 * The index outlives the set it points into: filtering shrinks the insights under a carousel
 * the user had already paged through. Both the entry a caller renders and the position label
 * read through here, so they cannot disagree about what is on screen.
 */
export const carouselPosition = (index: number, count: number): number =>
  count > 0 ? ((index % count) + count) % count : 0;
